import flicker1 from "../images/project-images/flicker/flicker1.png";
import ofm1 from "../images/project-images/ofm/ofm1.png";
import park1 from "../images/project-images/park/park1.png";
import signup1 from "../images/project-images/signup/signup1.png";
import lenden1 from "../images/project-images/lenden/lenden1.png";
import shop1 from "../images/project-images/shop/shop1.png";
import places1 from "../images/project-images/places/places1.png";

export const projects = [
  {
    id: "p5",
    title: "Flickr Groups",
    info:
      "Search Flickr groups, compare image counts, and browse photos in a masonry layout with infinite scrolling and data visualization.",
    link: "https://stoic-clarke-da7932.netlify.app/",
    githubLink: "https://github.com/lalitlsg/flickr-groups",
    tag: "React",
    motif: "masonry",
    image: flicker1,
  },
  {
    id: "p6",
    title: "ShopT",
    info:
      "React Native e-commerce app with product browsing, authentication, cart management, and checkout for buyers and sellers.",
    link: "https://expo.io/@lalitlsg/projects/shop",
    githubLink: "https://github.com/lalitlsg/react-native-shop-app-navigation-v5-",
    tag: "React Native",
    motif: "shop",
    image: shop1,
  },
  {
    id: "p4",
    title: "One For Me",
    info: "Connects customers with developers to design and launch custom websites.",
    link: "https://upbeat-einstein-10a425.netlify.app/",
    githubLink: "https://github.com/lalitlsg/one-for-me",
    tag: "React",
    motif: "match",
    image: ofm1,
  },
  {
    id: "p3",
    title: "Len-Den",
    info:
      "Tracks money you owe and are owed — useful with friends or for shops that sell on credit.",
    link: "https://lenden-68143.web.app/#/",
    githubLink: "https://github.com/lalitlsg/LenDen-Web-App",
    tag: "Vue",
    motif: "ledger",
    image: lenden1,
  },
  {
    id: "p1",
    title: "Parking App",
    info:
      "Manage organizational parking: park vehicles, view open slots, and charge 1 Rs/min on exit.",
    link: "https://parking-e486e.web.app",
    githubLink: "https://github.com/lalitlsg/Park-My-Vehicle",
    tag: "Vue",
    motif: "park",
    image: park1,
  },
  {
    id: "p7",
    title: "Places",
    info:
      "Save favorite places with photos and maps using native camera and location features.",
    link: "https://github.com/lalitlsg/react-native-places-app",
    githubLink: "https://github.com/lalitlsg/react-native-places-app",
    tag: "React Native",
    motif: "pin",
    image: places1,
  },
  {
    id: "p2",
    title: "Sign In",
    info: "Sign-in experience with Google, Facebook, and email registration.",
    link: "https://signup-24552.web.app",
    githubLink: "https://github.com/lalitlsg",
    tag: "Vue",
    motif: "lock",
    image: signup1,
  },
];
